/** Simplified Chinese overlay for the IA restructure. */

const taxonomyZh = {
  family: '家族',
  families: {
    all_weather: '全天候',
    directional: '方向性',
    market_neutral: '市场中性',
    momentum: '动量',
    high_octane: '高辛烷',
    intraday: '日内',
  },
  familyCopy: {
    all_weather: '按体制分散的组合。更低的股票贝塔、更慢的路径，作为组合的压舱。',
    directional: '指数与宏观择时。趋势中参与，市场健康恶化时离场。',
    market_neutral: '多空股票、贝塔接近零。是分散工具，不是对市场方向的押注。',
    momentum: '多周期美股动量。跟随强势；在均值回归中会落后。',
    high_octane: '带杠杆的 risk-on / risk-off。更高上限，更深回撤。',
    intraday: '纳斯达克期货日内策略。每个交易时段内系统化入场，时段收盘前平仓。不跨时段持仓；优势来自波动率体制。',
  },
};

export const iaZh = {
  nav: {
    portfolio: '组合',
    research: '研究',
    reports: '报告',
    quantLab: '量化实验室',
    macroTerminal: '终端',
    institutional: '机构',
    more: '更多',
    account: '账户',
    login: '登录',
    about: '关于我',
  },
  taxonomy: taxonomyZh,
  disclaimer: {
    label: '免责声明',
    body: '回测与研究权益曲线仅供教育。不构成投资建议或推荐。过往业绩不保证未来结果。实盘交易包含图表未计入的成本。',
  },
  strategyDetail: {
    compare: '在业绩页比较',
    portfolio: '加入组合',
    subscribe: '周报',
    curveVsSpy: '复权权益 vs 股票指数 = 100',
    pros: '存在的理由',
    cons: '取舍',
    deepDive: '完整分析',
  },
  strategies: {
    kicker: '系统化策略',
    colStrategy: '策略',
    volShort: '波动',
    modelsCtaTitle: '模型组合',
    modelsCtaBody: '这些策略的现成搭配，引擎与组合构建器相同。',
    openCard: '打开策略 →',
    intradayCardHint: '进入后可选择敞口：账户的 50% 到 500%。',
    filterAll: '全部',
    liveBadge: '实盘',
    expandGroup: '显示全部 {n} 个 ▸',
    collapseGroup: '收起 ▴',
    seeFamily: '查看全部 {n} 个 →',
    sizing: {
      title: '日内仓位',
      exposure: '敞口',
      exposureHint: '持仓期间账户的 {pct} 投入纳斯达克；手数由账户规模决定。',
      wholeContracts: '手数为整数：在此敞口下一手至少需要 {min} 的账户，10 万美元今天可交易 {n} 手。',
      grossNote: '不含佣金与滑点。',
    },
    variant: {
      label: '版本',
      standard: '标准版',
      ucits: 'UCITS 版',
      cardHint: '进入后可选：标准版或 UCITS 版。',
      notes: {
        heimdall: 'UCITS 是欧盟面向欧洲投资者销售基金的监管框架：同一信号，使用符合 UCITS 的工具并遵守集中度限制，以美元计。',
        metis: 'UCITS 是面向欧洲投资者销售基金的欧盟框架：同一信号，黄金与大宗商品各不超过 20%，其余为现金，以美元展示。',
      },
    },
    strategyDescriptions: {
      tyr: '全天候轮动',
      ares: '市场择时',
      ascalafo: '双层',
      deimos: '择时 + 风险',
      fobos: '双层 + 风险',
      bes: '趋势跟踪',
      janus: '市场中性',
      hraesvelgr: '进取全天候',
      eos: '纳斯达克期货日内',
      artemis: '每日一笔交易',
      helios: '逐小时趋势跟随',
      hyperion: '日间趋势，只做多',
      horai: '分散化日内组合',
      theia: '日内组合，多空兼有',
      astraeus: '每日一决，多空皆可',
      phaethon: '驾驭当日动能',
      hemera: '开盘之后，多空皆可',
      selene: '耐心，只做多',
      asteria: '每周一次，只在周一',
      aether: '广谱日内组合',
      heimdall: '宏观体制配置',
      metis: '多资产动量轮动',
    },
    strategyFullDescriptions: {
      tyr: 'TYR 是分散化的全天候轮动。它把风险铺到相关性低的经济体制上，并用自有信号调整敞口。名字来自北欧掌管秩序与纪律的神。',
      ares: 'ARES 是系统化市场择时。它读取市场整体的结构健康——不是单一标的——并在 risk-on 与 risk-off 之间切换。经 2008、2020 与 2022 验证。在 Wikifolio 实盘运行。',
      ascalafo: 'ASCÁLAFO 是双层择时系统：独立信号必须一致才会扭转敞口。与 ARES 同属方向性家族，在波动体制附近入场更紧。',
      deimos: 'DEIMOS 是高辛烷择时袖套。与 ARES 同一套市场健康逻辑，趋势干净时更进取，否则回撤更深。',
      fobos: 'FOBOS 在杠杆择时之上叠加波动层。波动体制转敌对时降风险，平静后再介入。',
      bes: 'BES 是多周期股票动量。保留在多个时间尺度上跑赢大市的标的，并砍掉做不到的。',
      janus: 'JANUS 是多空市场中性选股。每周再平衡，贝塔接近零：是分散工具，不是对市场方向的押注。',
      hraesvelgr: 'HRÆSVELGR 是全天候家族中 TYR 更进取的孪生策略。同样的体制纪律，更高的成长胃口，动量消退时更快转入防守。',
      eos: 'EOS 以希腊黎明女神命名。它在交易日的最初几个小时交易纳斯达克期货：沿当日倾向方向做系统化、经确认的入场，止损与目标固定，收盘前平仓。经 YGGDRASIL 审计：夏普接近 1.5，对指数贝塔为零。按 300% 敞口展示，不含佣金。',
      artemis: 'ARTEMIS 以希腊弓箭女神命名：每个交易日一支箭。在开盘后不久对纳斯达克期货建立一笔系统化仓位，多空皆可，止损与目标固定，收盘前平仓；主要宏观日不交易。按固定一手审计：夏普 1.3，贝塔为零。按 300% 敞口展示，不含佣金。',
      hyperion: 'HYPERION 以光之泰坦命名，自高处守望。它在日内交易纳斯达克期货且只做多：等待当日亮出底牌后顺势加入，止损与目标固定，收盘前离场。经 YGGDRASIL 按固定一手审计：夏普 1.4，贝塔为零。按 300% 敞口展示，不含佣金。',
      helios: 'HELIOS 以横越天空的太阳命名：跟随当日正在走出的方向。每小时检查一次纳斯达克期货是否坚定地朝一个方向漂移，若是则顺势加入，止损与目标固定，每个交易日至多数次，收盘前始终平仓。按固定一手审计：夏普 1.1，贝塔为零。按 300% 敞口展示，不含佣金。',
      horai: 'HORAI 以希腊时序女神命名，她们分掌一天的时辰。这是一个纳斯达克期货的分散化日内组合：账户分配给交易日不同时点上相互独立的系统化决策，收盘前全部平仓。这些决策相关性很低，因此保留了大部分收益，而回撤只有单一方法的一小部分。按 300% 敞口展示，不含佣金。',
      theia: 'THEIA 以视觉泰坦女神命名，她一眼看尽整日。这是纳斯达克期货的系统化日内组合，多空兼有，交易日内多次决策，隔夜不持仓。经 YGGDRASIL 审计。按 300% 敞口展示，不含佣金。',
      astraeus: 'ASTRAEUS 以黄昏泰坦、群星与四风之父命名。日内交易纳斯达克期货，多空皆可，每日最多一次决策，隔夜不持仓。经 YGGDRASIL 以固定一手审计：夏普 1.4，贝塔为零。按 300% 敞口展示，不含佣金。',
      phaethon: 'PHAETHON 以 Helios 之子命名，他曾驾驭太阳战车一日。日内交易纳斯达克期货，多空皆可，以固定止损驾驭当日动能，收盘前离场。经 YGGDRASIL 以固定一手审计：夏普 1.4，贝塔为零。按 300% 敞口展示，不含佣金。',
      hemera: 'HEMERA 以白昼女神命名，她是黑夜之女，每日清晨带来光明。日内交易纳斯达克期货，多空皆可，待开盘显露方向后入场，固定止损与目标，收盘前平仓。经 YGGDRASIL 以固定一手审计：夏普 1.3，贝塔为零。按 300% 敞口展示，不含佣金。',
      selene: 'SELENE 以月亮泰坦女神命名，她是 Helios 与 Eos 的姐妹。日内交易纳斯达克期货且只做多，每月只在她选定的少数几天出手，收盘时平仓。经 YGGDRASIL 以固定一手审计：未通过，一条硬规则未达标。按 300% 敞口展示，不含佣金。',
      asteria: 'ASTERIA 以流星泰坦女神命名，她是 Leto 的姐妹，后来化作提洛岛。只做多纳斯达克期货，每周一次：周日晚间买入，持有周一交易时段，在周一收盘前离场，或到达固定目标，或按时平仓，不设止损。经 YGGDRASIL 以固定一手审计：通过，夏普 1.3，无硬规则未达标；因每周只交易一次，最低样本规则（300 笔）经所有者决定关闭。按 300% 敞口展示，不含佣金。',
      aether: 'AETHER 以诸神呼吸的明亮上层空气命名，高于风雨。这是纳斯达克期货的系统化日内组合，多空兼有，交易日内多次决策，每次收盘前平仓。按 300% 敞口展示，不含佣金。',
      heimdall: 'HEIMDALL 以彩虹桥 Bifröst 的守望者命名，他能看见、听见一切，在变化来临时吹响 Gjallarhorn 号角。每月，它只用当时已公布的数据读取美国的增长与通胀，将其转化为四种体制的概率，并把组合分配到股票、美国国债、TIPS、黄金、大宗商品和短期国库券；每周的风险叠加层在波动或压力上升时降低敞口。同一信号，两个版本：标准版与 UCITS 版。标准版经 YGGDRASIL 审计：通过。',
      metis: 'METIS 以睿智谋略的泰坦女神命名，她是宙斯的第一位妻子、雅典娜的母亲。每月最后一个交易日，它在八个市场（股票、美国国债、黄金、大宗商品、房地产）中持有六个月涨幅最大的三个，且仅在其上涨时持有，否则持有现金；当波动率超过 15% 时，波动率刹车会降低敞口。两个版本，同一信号：标准版与 UCITS 版。标准版经 YGGDRASIL 审计：通过。UCITS 版未通过（两条硬性规则未达标），由所有者决定发布。',
    },
  },
  home: {
    ticker: {
      subtitle: '系统化研究 · 实盘业绩',
    },
    hero: {
      lead: '二十二套系统化策略。多套已实盘运行多年——可在 Wikifolio、Darwinex 和 eToro 跟踪。每页都有数字。',
      live: '实盘业绩',
      ctaReports: '周报',
      ctaTerminal: '打开终端',
    },
    regimeTeaser: {
      kicker: '自研',
      title: 'HMA 体制检测器',
      body: '六个隐马尔可夫模型。一个综合，前向评分。周围是实时交易台。订阅即可打开。',
      cta: '查看终端',
    },
    featured: {
      subtitle: '方向性 · 市场健康',
      cta: '打开 ARES →',
      description: '用健康综合指标做市场择时：条件支撑时保持投资，否则离场。在 Wikifolio 实盘运行。',
    },
    families: {
      title: '六个家族',
      subtitle: '同一套研究流程，在组合里承担不同工作。打开一个家族查看策略。',
    },
    snapshot: {
      label: '权益，同一起点',
      title: 'TYR 对比股票指数',
      hint: '同一起始日，复权到 100。对数坐标让 TYR 与指数可以一起读。',
      cta: '打开业绩',
    },
    products: {
      title: '可以订阅什么',
      reportsKicker: '研究',
      reportsTitle: '周报',
      reportsBody: '方法、组合演变以及刚结束的一周——按策略或整包。',
      reportsCta: '查看方案',
      terminalKicker: '体制',
      terminalTitle: 'HMA Terminal',
      terminalBody: 'HMA 自研六因子体制检测器——外加周围的实时交易台。打开它。',
      terminalCta: '打开终端',
    },
    instTeaser: {
      title: '委托，不是产品页',
      body: '为需要建造者的基金、家族办公室与交易台：策略设计、体制研究与风险 overlay。',
      cta: '查看委托页',
    },
  },
  insights: {
    title: '研究',
    subtitle: 'Substack 上的量化笔记。日历和体制引擎在终端里。',
    marketContext: '市场背景',
    marketContextHint: '完整体制、STIR 和流动性工具在终端中。',
    openTerminal: '打开终端',
    whereToInvestSubtitle: '多套策略已实盘运行，可在受监管平台跟踪真实业绩。',
    readOnSubstack: '在 Substack 阅读 →',
    strategyNamed: '策略 {name}',
  },
  weeklyReports: {
    revealPrice: '查看价格并订阅 →',
    universeLabel: '标的宇宙',
    popular: '热门',
    universe: {
      diversified: '分散化 ETF',
      index: '指数 ETF',
      equities: '上市股票',
      leveraged: '杠杆 ETF',
      futures: '纳斯达克期货',
    },
    cards: {
      TYR: '全天候体制轮动 — 每周研究报告',
      HRAESVELGR: '更进取的全天候轮动 — 每周研究报告',
      ARES: '宏观择时与保护 — 每周研究报告',
      JANUS: '多空市场中性 — 每周研究报告',
      BES: '多周期股票动量 — 每周研究报告',
      ASCALAFO: '带波动叠加的宏观择时 — 每周研究报告',
      DEIMOS: '进取宏观择时 — 每周研究报告',
      FOBOS: '带波动叠加的杠杆择时 — 每周研究报告',
      EOS: '纳斯达克期货日内 — 每周研究报告',
      ARTEMIS: '纳斯达克期货每日一笔交易 — 每周研究报告',
      HELIOS: '纳斯达克期货逐小时趋势跟随 — 每周研究报告',
      HYPERION: '纳斯达克期货日间趋势，只做多 — 每周研究报告',
      HORAI: '纳斯达克期货分散化日内组合 — 每周研究报告',
      THEIA: '纳斯达克期货日内组合，多空兼有 — 每周研究报告',
      ASTRAEUS: '纳斯达克期货每日一决，多空兼有 — 每周研究报告',
      PHAETHON: '纳斯达克期货日内动能，多空兼有 — 每周研究报告',
      HEMERA: '纳斯达克期货开盘后交易，多空兼有 — 每周研究报告',
      SELENE: '纳斯达克期货耐心做多日 — 每周研究报告',
      ASTERIA: '纳斯达克期货周一做多，每周一次 — 每周研究报告',
      AETHER: '纳斯达克期货广谱日内组合 — 每周研究报告',
      HEIMDALL: '宏观体制多资产配置，标准版与 UCITS 版 — 每周研究报告',
      METIS: '多资产动量轮动，标准版与 UCITS 版 — 每周研究报告',
    },
    disclaimerLabel: '免责声明',
    disclaimer: '这些报告仅供信息与教育。它们描述各策略的量化方法、模型与组合演变。它们不是交易信号、投资建议或个性化推荐。过往业绩不保证未来结果。投资前请自行研究并咨询持牌顾问。',
    notAvailable: '该策略暂不可购买',
    bundleNotAvailable: '套餐暂不可购买',
    checkoutFailed: '无法创建结账会话',
    checkoutStartFailed: '无法开始结账，请重试。',
  },
  checkout: {
    missingPrice: '该产品暂不可购买 — 缺少 Stripe 价格配置。',
    checkoutFailed: '无法开始结账',
    checkoutError: '结账错误：{message}',
    noSubscription: '未找到有效订阅',
    portalFailed: '无法打开订阅管理，请重试。',
  },
  contact: {
    fillAll: '请填写全部字段',
    sent: '消息已发送。我会尽快回复。',
    sendError: '发送失败，请重试。',
    connectionError: '连接错误，请稍后再试。',
    sending: '发送中…',
    methodLabel: '联系方式',
    methodHint: '用表单发消息。我通常在 24–48 小时内回复。',
  },
  common: {
    present: '至今',
  },
  performancePage: {
    kicker: '分析',
    title: '业绩',
    lead: '在策略之间、以及与股票指数比较。夏普、回撤、相关与风险指标，均来自已发布曲线。',
    dateRange: '日期范围',
    dateHint: '每条序列裁到此范围内的重叠日期，并在共同起点复权到 100。',
    equity: '权益曲线',
    logScale: '对数坐标',
    showRegime: '市场体制叠层',
    regimeHint: '背景色是六因子综合（risk-on → risk-off）。这是市场读数，不是策略信号。',
    regimeOn: 'Risk-on',
    regimeNeutral: '中性',
    regimeCautious: '谨慎',
    regimeOff: 'Risk-off',
    rollingSharpe: '滚动夏普',
    months: '{n} 个月',
    drawdown: '回撤',
    underwater: '水下',
    correlation: '相关性',
    correlationHint: '月度收益 · Pearson',
    metrics: '对比指标',
    strategies: '策略',
    benchmarks: '基准',
    selectAll: '全选',
    clear: '清除',
    needTwo: '至少选择两条序列才能看相关性',
    needOne: '至少选择一条序列才能看指标',
    needOneEquity: '至少选择一套策略或一个基准',
    needOneDrawdown: '至少选择一条序列才能看回撤',
    needOneSharpe: '至少选择一条序列才能看滚动夏普',
    rebased: '已复权到 100',
    rebasedFrom: '已复权到 100 · {date}',
    series: '序列',
    totalReturn: '总回报',
    volatility: '波动率',
    upMonths: '上涨月份占比',
    metricsNote: '指标在所选序列的重叠窗口上计算',
    metricsNoteRange: '在标记的日期范围内',
    metricsNoteAnnual: '夏普与索提诺使用相对 3 个月期美国国库券的每日超额收益，按 252 个交易日年化（周度曲线：周收益，52）。',
    maxPreset: '最大',
    typeStrategy: '策略',
    typeBenchmark: '基准',
  },
  portfolioPage: {
    kicker: '组合构建器',
    title: '构建你的组合',
    lead: '用自定义权重组合 HMA 策略，选择再平衡频率，并对主要基准做组合回测。',
    presets: '快速预设',
    loadModel: '加载模型组合',
    findProfile: '找到我的风险画像',
    optimizing: '优化中…',
    optimize: '按最大夏普优化',
    optimizeFailed: '优化失败 — 请尝试其他再平衡频率。',
    components: '组合成分',
    select: '选择…',
    addComponent: '添加成分',
    totalOk: '合计：{n}%',
    totalUnder: '合计：{n}% — 还剩 {left}%',
    totalOver: '合计：{n}% — 超过 100%',
    autoBalance: '自动平衡',
    rebalancing: '再平衡频率',
    rebalanceHint: '再平衡会定期把权重重置回你的目标配置。',
    monthly: '每月',
    quarterly: '每季',
    annually: '每年',
    never: '从不（买入持有）',
    logScale: '对数坐标',
    rebased: '已复权到 100',
    calculate: '计算组合',
    copied: '已复制！',
    copyLink: '复制链接',
    models: '模型组合',
    modelsHint: '加载现成搭配再计算。或在左侧自行构建。',
    myPortfolio: '我的组合',
    allocation: '配置',
    backtestRange: '回测区间',
    years: '{n} 年',
    rebalanced: '再平衡：{freq}',
    equityCurve: '权益曲线',
    fullMetrics: '完整指标',
    valueBase: '价值（基数 100）',
    returnPct: '回报 (%)',
    sharpeRatio: '夏普比率',
    maxDrawdown: '最大回撤',
    ddDuration: '回撤持续',
    bestYear: '最好年份',
    worstYear: '最差年份',
    posMonths: '正收益月份',
    compareVs: '对比',
    benchmarksHint: '虚线是参考指数，不属于组合组合。',
  },
  terminalLanding: {
    badge: '自研体制检测器',
    title: '市场体制检测器——在这里自建。',
    lead: '六个隐马尔可夫模型收成一个综合，从 risk-on 到 risk-off。周围是实时交易台：宏观、融资、内部。每天打开。',
    price: '每月 10,99 €。',
    ctaSignIn: '登录后订阅',
    ctaOpen: '打开终端 →',
    ctaBusy: '正在跳转…',
    ctaUnlock: '以每月 10,99 € 解锁',
    seeInside: '查看检测器',
    subscribed: '你已订阅 — 访问有效。',
    liveNow: '实时综合',
    liveAsOf: '截至 {date}',
    regimeEyebrow: '引擎',
    regimeTitle: 'HMA 体制检测器',
    regimeLead: '这是终端的自研核心。六个独立高斯 HMM——波动、趋势、广度、周期、流动性、估值——各自推断隐状态与加权风险。等权均值即综合。每一天都是前向评分：只用当天可得的信息。不是交易指令。是对盘面的读数。',
    regimePoints: [
      { t: '自研', d: '在这里设计并运行。HMA 用来读市场的同一套引擎——现在在你的屏幕上。' },
      { t: '六个因子', d: '波动、趋势、广度、周期、流动性、估值。独立模型，一个综合。' },
      { t: '前向', d: '没有前瞻。每一天只用自己的过去过滤。一套可以信任的历史。' },
      { t: '综合与敞口', d: '从 0（risk-on）到 1（risk-off）的一个数。建议敞口 = 1 − 综合，带 5 日滞后。' },
    ],
    shotsEyebrow: '交易台',
    shotsTitle: '订阅后打开的内容',
    shots: [
      { t: '体制检测器', d: '综合、六因子看板、因果历史。' },
      { t: '流动性带', d: '净流动性、隔夜利率、曲线。' },
      { t: 'STIR 监测', d: '走廊、准备金、融资压力。' },
      { t: '宏观仪表盘', d: '收益率、通胀、就业、信用、压力。' },
      { t: '市场内部', d: '指数之下的参与度。' },
      { t: '私募回购', d: '隔夜利率、成交量、窗口用量。' },
    ],
    lockedEyebrow: '锁定',
    lockedTitle: '更多面板，锁在后面',
    lockedHint: '订阅即可打开因子浏览器、信用、窗口与广度警报——不只是封面。',
    lockedCta: '解锁',
    lockedShots: [
      { t: '因子浏览器' },
      { t: '信用与压力' },
      { t: '窗口用量' },
      { t: '广度警报' },
      { t: '实地指南' },
      { t: '隔夜融资' },
      { t: '因子历史' },
      { t: '流动性特写' },
    ],
    previewKicker: '实时预览',
    previewTitle: '真实终端在下面运行。订阅即可去掉模糊。',
    insideEyebrow: '你得到什么',
    insideTitle: '先是检测器，然后是整张交易台',
    features: [
      { t: 'HMA 体制检测器', d: '六个独立高斯隐马尔可夫模型。一个从 risk-on 到 risk-off 的综合。在这里自建，不是外购授权。' },
      { t: '综合与敞口', d: '0 到 1 的一个数，建议敞口 1 − 综合，以及 5 日滞后，避免标签闪烁。' },
      { t: '前向历史', d: '每一天用当天可得信息打分——没有前瞻。一条可以回测的体制路径。' },
      { t: '因子浏览器', d: '打开任意因子：实时状态、风险路径，以及喂给模型的指标。' },
      { t: '流动性带', d: '系统净流动性对股票指数、隔夜利率与 2s10s 曲线——大势，一块屏幕。' },
      { t: 'STIR 监测', d: '隔夜走廊、尾部、准备金对逆回购、融资利差与货币市场资产——压力最先出现的地方。' },
      { t: '市场内部', d: '涨跌 4% 的个股、5 日与 10 日比率、25 日新高新低与 13/34 推力——不只看指数。' },
      { t: '宏观仪表盘', d: '完整收益率曲线、通胀与就业、HY 对 IG 信用、金融条件指数、美元与原油。' },
      { t: '私募回购', d: '三方、DVP 与 GCF 隔夜利率和成交量，加上窗口用量与对手方。' },
      { t: '实地指南', d: '每条序列的白话说明：含义、为何波动、如何阅读。' },
    ],
    howEyebrow: '如何运作',
    howTitle: '检测器给这一天打分。你来读。',
    steps: [
      { n: '01', t: '六个模型给今天打分', d: '每个因子推断隐状态与 [0,1] 风险——严格因果，没有前瞻。' },
      { n: '02', t: '一个综合', d: '等权均值、滞后、建议敞口。从 risk-on 到 risk-off，一个数字。' },
      { n: '03', t: '你打开终端', d: '检测器、历史、浏览器和其余交易台——登录即可用。' },
    ],
    membership: '会员',
    perMonth: '/ 月',
    cancel: '随时取消 · 按月计费',
    bullets: [
      '自研六因子体制检测器',
      '实时综合与建议敞口',
      '前向体制历史',
      '因子浏览器',
      '宏观、STIR、内部与回购面板',
      '每条序列的实地指南',
      '每日更新',
    ],
    faqEyebrow: '常见问题',
    faqTitle: '需要知道的',
    faq: [
      { q: '我到底在付什么？', a: '终端的实时访问：HMA 自研体制检测器、因子浏览器、因果历史以及其余交易台——每日更新。' },
      { q: '体制检测器是什么？', a: '在这里自建的六因子隐马尔可夫引擎。它不告诉你买什么。它告诉你市场的风险状态，每天，没有前瞻。' },
      { q: '这是投资建议吗？', a: '不是。这是量化研究与监测工具。全部内容为教育与信息——不是买卖任何东西的推荐。' },
      { q: '可以随时取消吗？', a: '可以。这是按月订阅，可在账户里一键取消；访问持续到计费周期结束。' },
    ],
    disclaimer: 'hmaquant 终端是量化研究与监测工具，仅供教育与信息。不构成投资建议，其中任何内容都不构成买卖任何证券的推荐。',
  },
  reportsFaq: {
    title: '常见问题',
    items: [
      { q: '我买的是什么？', a: '该策略的每周研究报告：方法、组合演变与上一周。不是交易指令，也不是个性化建议。' },
      { q: '可以取消吗？', a: '可以。在账户里管理订阅。访问持续到计费周期结束。' },
      { q: '年付是什么？', a: '收十个月的钱，送两个月。同一份报告，年度发票。' },
      { q: '套餐包含终端吗？', a: '套餐覆盖二十二份策略报告和宏观研究笔记。终端是单独的 10,99 € 产品。' },
    ],
  },
  footer: {
    tagline: '系统化研究。二十二套策略，同一流程。',
    intradayNote: '日内期货策略（EOS、ARTEMIS、HELIOS、HYPERION、HORAI、THEIA、ASTRAEUS、PHAETHON、HEMERA、SELENE、ASTERIA、AETHER）的曲线不含佣金与滑点，按账户 300% 的固定敞口展示（手数随账户规模变化），基于从 YGGDRASIL 审计复现的回测。',
  },
  accountHub: {
    reports: '我的报告',
    terminal: '终端',
    lab: '量化实验室',
  },
  quantLabPage: {
    kicker: '沙盒',
    blurb: '教学模拟——GBM、均值回归、隐马尔可夫、希腊值。不是实时交易台。',
    openTerminal: '打开终端',
    versionBar: 'QUANT LAB v1.0 · HMA QUANT STRATEGIES',
  },
  terminalChrome: {
    lab: '教学沙盒 · 非投资建议',
    modules: '{n} 个模块',
  },
  institutionalPage: {
    kicker: '委托',
    heroTitle: '为你的账本而建。不是产品目录。',
    heroBody: 'HMA 承接机构研究委托——系统化设计、体制工作与风险 overlay——面向需要建造者、而不是另一份通讯的基金、家族办公室与交易台。',
    ctaPrimary: '提交一份 brief',
    ctaSecondary: '我们如何工作',
    proofKicker: '公开可见',
    proof: [
      { value: '12', label: '套系统化策略已实盘运行' },
      { value: 'Live', label: 'Wikifolio、Darwinex 与 eToro 上的业绩' },
      { value: '6 HMM', label: '自研体制引擎，walk-forward' },
      { value: 'Desk', label: '物理、量化金融，买方与经纪商席位' },
    ],
    forTitle: '谁该写信',
    forBody: '如果你已经有问题，一次通话就能定范围。如果你要的是供应商宣传册，这不是那一页。',
    for: [
      { title: '家族办公室 / 配置人', body: '一个必须在整本账旁边站得住的 sleeve。我们设计流程、风险预算和 kill-switch——不是一叠回测路演。' },
      { title: 'CIO / 风险', body: '体制 overlay、回撤协议，或一次独立判断：当前的账是否还是你以为的那本账。' },
      { title: '系统化交易台', body: '你不想内部编制的模块：信号研究、walk-forward、监控规格，或对实盘流程的第二双眼睛。' },
    ],
    workTitle: '我们接的委托',
    workBody: '公开网站是工作样本。委托走得更远：你的数据、你的约束、你的账本。',
    work: [
      { title: '系统化策略设计', body: '从假设到可运行的流程。宇宙、信号、执行假设、walk-forward，以及资金承担风险之前写清的失效模式。', tag: '新 sleeve · 重建' },
      { title: '体制与宏观研究', body: '终端里的六因子 HMM 栈，按你的账本规格化：何时加风险、何时减、对你而言中性意味着什么。', tag: 'Overlay · 择时' },
      { title: '风险 overlay 与回撤协议', body: 'Kill-switch、波动率目标、压力路径，以及 CIO 能在委员会上站得住的操作规则——不是幻灯片上的一个 VaR。', tag: '风险 · overlay' },
      { title: '组合构建', body: '各部分如何坐在一起。风险预算、相关体制，以及两个分散器开始同向时该怎么办。', tag: '家族办公室 · 多策略' },
      { title: '留任研究', body: '每周或每月：笔记、诊断，以及已经了解账本的人。更接近交易台，而不是咨询 PDF。', tag: '持续' },
    ],
    processTitle: '一次委托如何进行',
    processBody: '短范围、书面假设，成果归你。',
    process: [
      { n: '01', title: 'Brief', body: '你给出问题、约束，以及“完成”长什么样。我们说行、不行，或还不到时候。' },
      { n: '02', title: '范围', body: '一页短说明：交付物、所需数据、时间、费用。不做钓鱼式尽调。' },
      { n: '03', title: '构建', body: '与你一起公开做研究。代码、图表和假设写到别人也能复跑。' },
      { n: '04', title: '移交', body: '成果归你。可选留任，让流程随体制一起活着。' },
    ],
    deliverTitle: '你带走什么',
    deliver: [
      { title: '书面流程', body: '不是黑箱。信号、数据，以及允许交易的规则。' },
      { title: '研究包', body: 'Walk-forward、失效案例，以及委员会真正读得下去的图。' },
      { title: '若需要，给代码', body: '可复现笔记本或小型服务。由你来跑。' },
      { title: '操作规格', body: '监控什么、关掉什么、警报发给谁。' },
    ],
    notTitle: '这不是什么',
    notItems: [
      '我们不托管你的 AUM。实盘记录在受监管平台上——证明流程，不是募资。',
      '我们不卖无主的信号倾倒或模型。',
      '我们不接每一份 brief。若是通讯，产品在报告页。若是交易台问题，写信。',
    ],
    sampleTitle: '公开工作样本',
    sampleBody: '策略、业绩与终端是我们已经在跑的东西。委托是同一门手艺，按你来规格化。',
    samples: [
      { to: '/strategies', label: '二十二套策略' },
      { to: '/performance', label: '业绩' },
      { to: '/terminal', label: '体制交易台' },
    ],
    formKicker: '接入',
    formTitle: '发一份短 brief',
    formBody: '机构、问题、约束。我们自己回复。',
    formName: '姓名',
    formFirm: '机构',
    formEmail: '邮箱',
    formNeed: '你需要什么',
    formNeedPlaceholder: '选择委托类型',
    formMessage: 'Brief',
    formSend: '发送 brief',
    formSending: '发送中…',
    formOk: '已收到。我们会回你。',
    formErr: '这边发不出去——用邮件链接，一样能到。',
    formMail: '改用邮件 →',
    formNote: '保密。没有销售队列。若 brief 不合适，我们会直说。',
    needs: [
      { id: 'strategy', label: '策略设计' },
      { id: 'regime', label: '体制 / overlay' },
      { id: 'risk', label: '风险 / 回撤协议' },
      { id: 'portfolio', label: '组合构建' },
      { id: 'retain', label: '留任研究' },
      { id: 'other', label: '其他——我会说明' },
    ],
    ctaLine: '如果这个问题已经让你睡不着，写下来。',
  },
};
